<template>
  <p><strong>Notwendig</strong></p>
  <MDBSwitch
    disabled
    label="Notwendige Cookies Speichern"
    v-model="Default"
  />
  <p>Notwendige Cookies helfen dabei, eine Webseite nutzbar zu machen, indem sie Grundfunktionen wie Seitennavigation und Zugriff auf sichere Bereiche der Webseite ermöglichen. Die Webseite kann ohne diese Cookies nicht richtig funktionieren.</p>

  <p> <strong>Google Analytics</strong> </p>
  <MDBSwitch
    label="Google Analytics Cookies Speichern"
    v-model="GoogleAnalytics"
  />
  <p>Wir verwenden Google Analytics Cookies um zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.</p>

</template>

<script>
import { MDBSwitch } from "mdb-vue-ui-kit"
import { useState } from "vue-gtag-next"

export default {
  name: 'OptInOut',
  components: {
    MDBSwitch,
  },
  data() {
    return {
      Default: true,
      GoogleAnalytics: true,
     };
  },
  watch: {
        GoogleAnalytics: function(val) {
          if(val == true) {
            this.$cookie.setCookie('UmzugBayernConsentGoogleAnalytics', true, {
              expire: '180d',
              path: '/',
              domain: '',
              secure: '',
              sameSite: '',
            })
            useState().isEnabled.value = true
          }
          if(val == false) {
            this.$cookie.setCookie('UmzugBayernConsentGoogleAnalytics', false, {
              expire: '180d',
              path: '/',
              domain: '',
              secure: '',
              sameSite: '',
            })
            useState().isEnabled.value = false
          }
        }
    },
  created: function(){
    if(this.$cookie.getCookie('UmzugBayernConsentGoogleAnalytics') == 'false') {
      this.GoogleAnalytics = false
    } else {
      this.GoogleAnalytics = true
    }
  },
  methods: {
    onSubmit() {

    }
  }
}
</script>
